const investmentUpdates = (state = {}, action) => {
  switch (action.type) {
    default: return state;
  }
};

export default investmentUpdates;
